"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M181.8 89.6C93.2 89.6 21.4 161.4 21.4 250s71.8 160.4 160.4 160.4S342.2 338.6 342.2 250 270.4 89.6 181.8 89.6zm-80.3 140.3c0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1-11.1 0-20.1-9-20.1-20.1zm146.4 79c-1.3.9-33.2 21.9-66.1 21.9-32.9 0-64.8-21-66.1-21.9-4.9-3.3-6.2-9.9-2.9-14.7 3.3-4.9 9.9-6.2 14.7-2.9.3.2 27.9 18.3 54.3 18.3 26.6 0 54-18.1 54.3-18.3 4.9-3.3 11.5-1.9 14.7 2.9 3.3 4.9 2 11.5-2.9 14.7zm-6-58.9c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1zm157.6 0c-12.5 0-24.2 3.1-34.8 8.2-1.8 39.2-15.8 75.2-38.5 104.3 12.4 28.2 40.5 47.9 73.3 47.9 44.3 0 80.2-35.9 80.2-80.2S443.8 250 399.5 250zm-40.1 70.2c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10-10-4.5-10-10zm74.6 48c-1 1.5-2.7 2.4-4.4 2.4-1 0-2-.3-2.9-.9-.1-.1-14-9.1-27.2-9.1-13.3 0-27 9-27.2 9.1-2.4 1.6-5.7 1-7.4-1.5-1.6-2.4-1-5.7 1.5-7.4.7-.4 16.5-10.9 33-10.9 16.4 0 32.4 10.4 33 10.9 2.6 1.7 3.3 5 1.6 7.4zm-4.5-38c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z"
  });
};

exports.default = _default;